import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {State} from '../../../reducers'
import {sujetoExcluidoClearAll} from '../../../actions/sujeto-excluido/sujetoExcluidoEmision.actions'
import { docsDatosReceptorReset } from '../../../actions/documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../../../actions/forma-pago.actions'

const SEEncabezado = (props: any) => {
  const dispatch = useDispatch()
  const facturaEmitida = useSelector((state: State) => state.sujetoExcluido.facturaEmitda)

  const nuevaFactura = () => {
    if (facturaEmitida) {
      dispatch(sujetoExcluidoClearAll())
      dispatch(docsDatosReceptorReset())
      dispatch(handleRestartStateFormaPago())
    }
  }

  return (
    <>
      <div className='header-link'>
        <Link to={props.url} className='back-button w-inline-block' onClick={nuevaFactura}></Link>
        <h3 className='h3-titles xl'>Factura de Sujeto Excluido</h3>
      </div>
      <div className='separador'></div>
    </>
  )
}

export default SEEncabezado
